import { configurationSchema } from "../configuration/configuration";
import i18n from "../language/i18n";
import { Units } from "../types/sharedTypes";

/**
 * Reads config JSON and InfoModal out of AWS S3 Bucket and validates it.
 */
export const downloadConfig = async () => {
  try {
    // Fetch config from AWS.
    const config = await fetch(process.env.REACT_APP_CONFIG_URL!).then((res) =>
      res.json()
    );

    // Validate it against our schema.
    await configurationSchema.validate(config);

    // Fetch info modal from AWS.
    const language = i18n.language;
    const infoModal = await fetch(
      process.env.REACT_APP_MODAL_URL + "_" + language + ".md"
    ).then((res) => res.text());

    // Everythings fine.
    return { config, infoModal };
  } catch {
    throw new Error();
  }
};
